import { Link } from "@tanstack/react-router";
import logoAsset from "@/assets/logo-pajar-benito-224.webp.asset.json";
import cartelAsset from "@/assets/cartel-fie-jccm.webp.asset.json";
import { useSiteData } from "@/lib/use-site-data";
import { openCookiePreferences } from "@/lib/consent";

export function SiteFooter() {
  const { config } = useSiteData();
  const waNumber = (config.whatsapp ?? "").replace(/\D/g, "");
  const waDisplay = config.telefono_contacto || (waNumber ? `+${waNumber}` : "");
  return (
    <footer className="mt-24 border-t border-border/60 bg-secondary/40">
      {/* FINANCIACIÓN — antes de contacto, navegación y legal */}
      <div className="border-b border-border/60">
        <div className="mx-auto max-w-4xl px-4 py-10 text-center md:px-6">
          <Link to="/financiacion" className="inline-block">
            <img
              src={cartelAsset.url}
              alt="Cartel oficial del proyecto financiado por el Fondo Europeo de Desarrollo Regional y la Junta de Comunidades de Castilla-La Mancha"
              width={240}
              height={339}
              loading="lazy"
              className="mx-auto h-auto w-48 rounded-sm border border-border bg-background shadow-sm md:w-56"
            />
          </Link>
          <p className="mt-5 text-sm leading-relaxed text-muted-foreground md:text-base">
            Proyecto beneficiario de las subvenciones de la Junta de Comunidades de Castilla-La Mancha: Ayudas –Adelante Inversión–, cofinanciado por el Fondo Europeo de Desarrollo Regional.{" "}
            <Link to="/financiacion" className="font-medium text-primary hover:text-primary/80">
              Ver cartel y certificado
            </Link>
          </p>
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 md:grid-cols-3 md:px-6">
        {/* col 1 */}
        <div>
          <img
            src={logoAsset.url}
            alt="El Pajar de Benito · Casa Rural"
            width={140}
            height={140}
            className="h-32 w-32 object-contain"
          />
          <address className="mt-3 not-italic text-sm leading-relaxed text-muted-foreground">
            {config.direccion}<br />
            {config.codigo_postal} {config.ciudad}<br />
            {config.pais}
          </address>
        </div>
        {/* col 2 */}
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-foreground/70">
            Contacto
          </p>
          <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
            {config.email_contacto && (
              <li>
                <a href={`mailto:${config.email_contacto}`} className="hover:text-primary">
                  {config.email_contacto}
                </a>
              </li>
            )}
            {waNumber && (
              <li>
                <a
                  href={`https://wa.me/${waNumber}`}
                  target="_blank"
                  rel="noopener"
                  className="hover:text-primary"
                >
                  WhatsApp {waDisplay}
                </a>
              </li>
            )}
          </ul>
        </div>
        {/* col 3 */}
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-foreground/70">
            Navegación
          </p>
          <ul className="mt-3 grid grid-cols-2 gap-y-2 text-sm text-muted-foreground">
            <li><Link to="/alojamiento" className="hover:text-primary">Alojamiento</Link></li>
            <li><Link to="/entorno" className="hover:text-primary">Entorno</Link></li>
            <li><Link to="/galeria" className="hover:text-primary">Galería</Link></li>
            <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
            <li><Link to="/reserva" className="hover:text-primary">Reservar</Link></li>
            <li><Link to="/contacto" className="hover:text-primary">Contacto</Link></li>
            <li><Link to="/financiacion" className="hover:text-primary">Financiación</Link></li>
            <li><Link to="/san-silvestre-sierra-norte" className="hover:text-primary">San Silvestre</Link></li>
          </ul>
          <p className="mt-6 text-xs font-medium uppercase tracking-[0.18em] text-foreground/70">
            Descubre
          </p>
          <ul className="mt-3 grid grid-cols-1 gap-y-2 text-sm text-muted-foreground">
            <li><Link to="/casa-rural-guadalajara" className="hover:text-primary">Casa rural en Guadalajara</Link></li>
            <li><Link to="/casa-rural-con-chimenea" className="hover:text-primary">Casa rural con chimenea</Link></li>
            <li><Link to="/casa-rural-cerca-madrid" className="hover:text-primary">Casa rural cerca de Madrid</Link></li>
            <li><Link to="/casa-rural-guadalajara-grupos" className="hover:text-primary">Casa rural para grupos</Link></li>
            <li><Link to="/casa-rural-sierra-norte-guadalajara" className="hover:text-primary">Sierra Norte de Guadalajara</Link></li>
            <li><Link to="/casa-rural-pueblos-negros" className="hover:text-primary">Pueblos negros de Guadalajara</Link></li>
            <li><Link to="/casa-rural-hayedo-tejera-negra" className="hover:text-primary">Cerca del Hayedo de Tejera Negra</Link></li>
            <li><Link to="/casa-rural-escapada-romantica" className="hover:text-primary">Escapada romántica</Link></li>
          </ul>
          <p className="mt-6 text-xs font-medium uppercase tracking-[0.18em] text-foreground/70">
            Legal
          </p>
          <ul className="mt-3 grid grid-cols-2 gap-y-2 text-sm text-muted-foreground">
            <li><Link to="/legal/aviso-legal" className="hover:text-primary">Aviso legal</Link></li>
            <li><Link to="/legal/privacidad" className="hover:text-primary">Privacidad</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-primary">Cookies</Link></li>
            <li><Link to="/legal/condiciones" className="hover:text-primary">Condiciones</Link></li>
            <li>
              <button
                type="button"
                onClick={openCookiePreferences}
                className="text-left hover:text-primary"
              >
                Configuración de cookies
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="mx-auto max-w-6xl px-4 py-5 md:px-6">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} {config.nombre_comercial} · Alojamiento rural en {config.ciudad}, {config.pais}
            </p>
            <Link
              to="/gestion"
              className="text-xs text-muted-foreground/60 hover:text-muted-foreground"
            >
              Acceso gestión
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
